/**
 * Registers every `executionMode: 'client-side'` entity definition from
 * `@fias/client-entities` against the client-entity registry. Side-effect
 * imported once from `main.tsx` so registration happens before any arche
 * renders.
 *
 * This module is the ONLY intended consumer of the definition objects — it
 * is the seam between the executor implementations (the workspace package)
 * and the registry (the single client-lane dispatch point, which owns
 * permission gating and rate limiting). Registration is idempotent:
 * `registerClientEntity` replaces a prior registration for the same ID, so
 * re-evaluating this module (Vite HMR, `vi.resetModules()`) is safe.
 *
 * Add a new client-side entity: export its definition from
 * `@fias/client-entities` and register it here. The architecture test
 * `tests/architecture/client-entity-registry-mirrors-entity-config.test.ts`
 * pins the definition literals against the entity catalog AND asserts this
 * module registers every definition — a forgotten registration fails CI.
 */

import { registerClientEntity } from '@/lib/client-entity-registry';
import {
  nllbTranslationDefinition,
  grammarCheckDefinition,
  pluginContentDefinition,
  configurePluginContentHost,
} from '@fias/client-entities';
import { pluginContentHost } from '@/lib/plugin-content-host';

registerClientEntity(nllbTranslationDefinition.entityId, nllbTranslationDefinition);
registerClientEntity(grammarCheckDefinition.entityId, grammarCheckDefinition);
// Plugin content packs read through this page's credential + cache, which the
// executor receives here because its context carries only { userId, archeId }.
configurePluginContentHost(pluginContentHost);
registerClientEntity(pluginContentDefinition.entityId, pluginContentDefinition);
